import React from 'react';
import type { ReactNode, HTMLProps } from 'react';

import cx from '../../utils/classNames';
import toCamelCase from '../../utils/toCamelCase';

import styles from './textArea.module.scss';

export type Props = {
  /** Custom style for wrapper */
  className?: string;

  /** Children elements */
  children: ReactNode;
} & Omit<HTMLProps<HTMLElement>, 'children' | 'className'>;

function TextArea(props: Props) {
  const { className, children } = props;

  return (
    <div
      className={cx(className, styles[toCamelCase('textArea', 'container')])}
      data-testid="textArea-container"
    >
      {children}
    </div>
  );
}

export default TextArea;
